<template>
  <v-card class="mx-auto aborder">
    <v-card-title class="d-flex flex-column">
      <h1>{{ $t("english_graduate.officer_page") }}</h1>
    </v-card-title>
    <v-card width="95%" class="mx-auto px-2 pb-2 tborder" elevation="4">
      <v-card-title class="d-flex flex-column">
        <h3>{{ $t("english_graduate.basic") }}</h3>
      </v-card-title>
      <v-row>
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.student_id") }} : <b>{{ std_id }}</b></v-col
        >
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.name") }} :
          <b>{{ inlineTranslator({ en: fname_en, th: fname_th }) }}</b></v-col
        >
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.surname") }} :
          <b>{{ inlineTranslator({ en: lname_en, th: lname_th }) }}</b></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.admis_year") }} :
          <b
            >{{ admis_term }} /
            {{ inlineTranslator({ en: admis_year_en, th: admis_year }) }}</b
          ></v-col
        >
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.level") }} :
          <b>{{
            inlineTranslator({ en: level_name_en, th: level_name_th })
          }}</b></v-col
        >
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.curriculum_type") }} :
          <b>{{
            inlineTranslator({ en: curr_etype, th: curr_type })
          }}</b></v-col
        >
      </v-row>
      <v-row>
        <v-col cols="4" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.faculty") }} :
          <b>{{
            inlineTranslator({ en: faculty_ename, th: faculty_name })
          }}</b></v-col
        >
        <v-col cols="8" class="text-left pl-2 pl-md-6"
          >{{ $t("english_graduate.curriculum") }} :
          <b>{{
            inlineTranslator({ en: curr_ename, th: curr_tname })
          }}</b></v-col
        >
      </v-row>
    </v-card>
    <div class="pb-5">
      <v-card
        width="95%"
        class="mx-auto mt-2 pa-2 pl-md-6 pr-md-6 bborder"
        elevation="4"
        ><v-card-title class="d-flex flex-column"
          ><h3>{{ $t("english_graduate.form") }}</h3></v-card-title
        >
        <p class="tex1">
          {{ $t("english_graduate.student_english_status") }} :
          <span :style="{ color: getPassColor() }"
            ><b>{{
              inlineTranslator({ en: e_type_en, th: e_type_th })
            }}</b></span
          >
        </p>
        <hr />
        <v-row class="pt-4"
          ><v-col cols="4"
            ><p class="tex">
              {{ $t("english_graduate.select_criteria") }} :
              <b>
                {{
                  inlineTranslator({
                    en: getTextByCodeEn(record.study),
                    th: getTextByCodeTh(record.study),
                  })
                }}
              </b>
            </p> </v-col
          ><v-col cols="4"
            ><p class="tex">
              {{ $t("english_graduate.select_exam") }} :
              <b>{{ record.exam_type }}</b>
            </p>
          </v-col>
          <v-col cols="4"
            ><p class="tex">
              {{ $t("english_graduate.set_score") }} :
              <a
                href="https://www.reg.kmitl.ac.th/filecontainer/files/EnglishCriteria.pdf"
                target="_blank"
                ><v-btn small color="info">click here</v-btn></a
              ><b class="indigo--text"> ( {{ record.minimum_score }} )</b>
            </p></v-col
          ></v-row
        ><v-row
          ><v-col cols="4"
            ><p class="tex">
              {{ $t("english_graduate.score") }} : <b>{{ record.score }}</b>
            </p> </v-col
          ><v-col cols="4"
            ><p class="tex">
              {{ $t("english_graduate.pass_date") }} :
              <b>{{ dt(record.pass_date) }}</b>
            </p>
          </v-col></v-row
        ><v-card-text>
          <div class="d-flex flex-column justify-space-between align-center">
            <h2 class="pa-2 blackt">{{ $t("english_graduate.proof") }}</h2>
            <v-img
              v-if="isImage"
              height="100%"
              :src="imageSrc"
              class="picu"
            ></v-img>
            <embed
              v-else
              :src="imageSrc"
              width="100%"
              height="800px"
              type="application/pdf"
            />
          </div>
          <div class="text-center py-2 blackt">
            <v-row
              ><v-col cols="8" class="mx-auto"
                ><h3 class="text-left pt-2">
                  {{ $t("english_graduate.comment") }}
                </h3>
                <v-textarea
                  background-color="grey lighten-3"
                  v-model="comment"
                ></v-textarea></v-col
            ></v-row>
            <v-btn
              color="red"
              :disabled="record.status_id == 3"
              style="color: white"
              @click="setStatusandComment(3)"
              >{{ $t("english_graduate.not_pass") }}</v-btn
            >
            <v-btn
              color="green"
              :disabled="record.status_id == 2"
              style="color: white"
              class="ml-2"
              @click="setStatusandComment(2)"
              >{{ $t("english_graduate.pass") }}</v-btn
            >
            <h2 class="mt-3 blackt">
              {{ $t("english_graduate.current_status") }} :
              <v-chip :color="getChipColor(record.status_id)">
                {{
                  inlineTranslator({
                    en: getTextByStatusEn(record.status_id),
                    th: getTextByStatusTh(record.status_id),
                  })
                }}
              </v-chip>
            </h2>
          </div></v-card-text
        ></v-card
      >
    </div>
  </v-card>
</template>
<script>
import EnglishProvider from "@/services/english.provider.js";
const EnglishService = new EnglishProvider();

import { inlineTranslator } from "@/helper/translator";
import {
  objectTranslator,
  dateFromDBTranslatorFull as dt,
} from "@/helper/translator";
export default {
  name: "EnglishSubmitVeriy",

  data: () => ({
    loading: null,
    isImage: false,
    comment: null,
    rand: null,
    imageSrc: null,

    admis_year: null,
    admis_term: null,
    level: null,
    level_name_th: null,
    level_name_en: null,
    faculty_name: null,
    faculty_ename: null,
    curr_tname: null,
    curr_ename: null,
    inter_curr: null,
    curr_type: null,
    curr_etype: null,
    e_type_id: null,
    e_type_th: null,
    e_type_en: null,
    record: null,
    pass_result_th: { 1: "รอตรวจสอบ", 2: "ผ่าน", 3: "ไม่ผ่าน" },
    pass_result_en: { 1: "Pending approval", 2: "Passed", 3: "Not Passed" },
    condition_th: {
      0: "ไม่เรียนวิชาอังกฤษ",
      1: "เรียนวิชาอังกฤษ 1 วิชา",
      2: "เรียนวิชาอังกฤษ 2 วิชา",
    },
    condition_en: {
      0: "No English subject",
      1: "Learn 1 English subject",
      2: "Learn 2 English subjects",
    },
  }),
  methods: {
    dt,
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      this.loading = true;

      const data = await EnglishService.getEnglishStudentSubmission(
        this.std_id,
        this.version
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.fname_th = data.FNAME_TH;
      this.lname_th = data.LNAME_TH;
      this.fname_en = data.FNAME_EN;
      this.lname_en = data.LNAME_EN;
      this.admis_year = data.ADMIS_YEAR;
      this.admis_term = data.ADMIS_TERM;
      this.level = data.LEVEL;
      this.level_name_th = data.LEVEL_NAME_TH;
      this.level_name_en = data.LEVEL_NAME_EN;
      this.faculty_name = data.FACULTY_NAME;
      this.faculty_ename = data.FACULTY_ENAME;
      this.curr_tname = data.CURR_TNAME;
      this.curr_ename = data.CURR_ENAME;
      this.inter_curr = data.CURR_TYPE;
      if (!data.E_TYPE_ID || data.E_TYPE_ID === null) {
        this.e_type_th = "ยังไม่ผ่าน";
        this.e_type_en = "Not Passed";
      } else {
        this.e_type_id = data.E_TYPE_ID;
        this.e_type_th = data.E_TYPE_TH;
        this.e_type_en = data.E_TYPE_EN;
      }
      if (data.CURR_TYPE == 0) {
        this.curr_type = "ทั่วไป";
        this.curr_etype = "General";
      } else {
        this.curr_type = "นานาชาติ";
        this.curr_etype = "International";
      }
      if (data.RECORD) {
        this.record = data.RECORD;
        this.comment = this.record.comment;
      } else {
        this.record = null;
      }
      this.getEnglishProof();
    },

    getTextByCodeTh(code) {
      return this.condition_th[code] || "";
    },
    getTextByCodeEn(code) {
      return this.condition_en[code] || "";
    },
    getTextByStatusTh(status) {
      return this.pass_result_th[status] || "";
    },
    getTextByStatusEn(status) {
      return this.pass_result_en[status] || "";
    },
    getChipColor(status) {
      switch (status) {
        case "1":
          return "amber lighten-1";
        case "2":
          return "green";
        case "3":
          return "red";
        default:
          return "grey";
      }
    },
    getPassColor() {
      if (this.e_type_id == 51 || this.e_type_id == 53) {
        return "blue";
      } else if (
        this.e_type_id == null ||
        !this.e_type_id ||
        this.e_type_id == 99
      ) {
        return "red";
      } else {
        return "green";
      }
    },

    async getEnglishProof() {
      this.loading = true;
      if (this.imageSrc) {
        window.URL.revokeObjectURL(this.imageSrc);
        this.rand = Math.random();
      }
      const data = await EnglishService.getGraduateStudentEnglishProof({
        student_id: this.std_id,
        version_id: this.version,
        rand: this.rand,
      }).catch(() => {});
      if (data) {
        this.imageSrc = window.URL.createObjectURL(data);
        this.isImage = data.type.startsWith("image/");
      }
      this.loading = false;
    },

    async setStatusandComment(value) {
      this.loading = true;

      const response = await EnglishService.saveStatusandComment({
        student_id: this.std_id,
        version_id: this.version,
        status_id: value,
        approver_id: this.officer_id,
        comment: this.comment,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });
      if (response && response.status) {
        this.$toasted.success(this.$t("toasted.save_successfully"));
        this.fetch_data();
        if (response.status === true && value === 2) {
          this.setEnglishType();
        }
      } else
        this.$toasted.error(this.$t("toasted.cannot_save"), {
          duration: 0,
        });

      this.loading = false;
    },

    async setEnglishType() {
      this.loading = true;

      const response = await EnglishService.saveEnglishType(
        this.std_id,
        this.record.study,
        this.record.english_type_id,
        this.record.pass_date
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });
      if (response && response.status) {
        this.$toasted.success(this.$t("toasted.save_successfully"));
      } else
        this.$toasted.error(this.$t("toasted.cannot_save"), {
          duration: 0,
        });

      this.loading = false;
    },
  },

  computed: {
    std_id() {
      return this.$route.query.std_id;
    },
    officer_id() {
      return this.$store.state.user.user_info.payload.ticket.user_id;
    },
    version() {
      return this.$route.query.version;
    },
    year_now() {
      return this.$store.state.registration.yearNow;
    },
    semester_now() {
      return this.$store.state.registration.semesterNow;
    },
    admis_year_en() {
      return parseInt(this.admis_year) - 543;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
<style scoped>
table.v-simple-table tbody td {
  height: 40px;
  border: none;
}
.theme--light.v-simple-table tbody tr:not(:last-child) {
  border-bottom: none;
}
.aborder {
  border: 2px solid #bbbbbb;
  border-radius: 10px;
}
.tborder {
  border: 0px solid #000000;
}

.blackt {
  font-weight: 800;
  color: #000000;
}

.picu {
  border: 1px black solid;
}

.tex {
  font-size: 16px;
  font-weight: normal;
}

.tex1 {
  font-size: 20px;
  font-weight: normal;
}
</style>
